import { useState } from "react";
import NavBar from "./components/Menu";
import Header from "./components/Header";
import Company from "./components/Company";
import Faq from "./components/Faq";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Footer from "./components/Footer";
import GlobalStyle from "./globalStyles";
import { BrowserRouter as Router } from "react-router-dom";
import Advantage from "./components/card/Advantage";
import { ReactComponent as Logo } from "./img/mtk-one.svg";

import styled from "styled-components";

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelect] = useState("");

  return (
    <Router>
      <GlobalStyle />
      <NavBar
        selected={selected}
        setSelect={setSelect}
        isMobile={isMobile}
        setIsMobile={setIsMobile}
      />
      <WhatsAppFloat isMobile={isMobile} />
      <div
        style={{
          width: "100%",
          height: "10vh",
          background: "trasparent",
        }}
      ></div>
      <MtkOneBanner>
        <div className="inner">
          <a
            className="brand"
            href="https://www.mtkone.com/"
            aria-label="MTK One"
          >
            <Logo className="logo" />
          </a>

          <div className="copy">
            <h6>mobilParceiros está de cara nova!</h6>
            <p>
              <a href="https://www.mtkone.com/">acesse agora</a> o nosso novo
              site e descubra as vantagens de ser um parceiro MTK One
            </p>
          </div>
        </div>
      </MtkOneBanner>
      <Header />
      <Advantage />
      <Company />
      <Faq />
      <Footer />
    </Router>
  );
}

export const MtkOneBanner = styled.section`
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;

  .inner {
    max-width: 85rem;
    margin: 0 auto;
    padding: 3rem 1rem;
    display: flex;
    align-items: center;
    gap: 4rem;
    font-family: "Noto Sans", sans-serif !important;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #111;
    flex: 0 0 auto;
  }

  .logo {
    height: 2.5rem;
    color: black;
  }

  .brand span {
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.2px;
  }

  .copy {
    min-width: 0;
  }

  .copy h6 {
    color: #000;

    /* heading/h6 */
    font-size: var(--font-size-heading-h6, 1.25rem);
    font-style: normal;
    font-weight: var(--type-font-weight-bold, 700);
    line-height: var(--line-height-heading-h6, 1.5rem); /* 120% */
  }

  .copy p {
    color: #000;

    /* body/lg */
    font-size: var(--font-size-body-lg, 1.125rem);
    font-style: normal;
    font-weight: var(--type-font-weight-regular, 400);
    line-height: var(--line-height-body-lg, 1.75rem);
  }

  .copy a {
    color: #366cd9;
    text-align: center;

    /* body/lg-link */
    font-size: var(--font-size-body-lg, 1.125rem);
    font-style: normal;
    font-weight: var(--type-font-weight-regular, 400);
    line-height: var(--line-height-body-lg, 1.75rem); /* 155.556% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  @media (max-width: 640px) {
    .inner {
      flex-direction: column;

      padding: 1.5rem 1rem;
      gap: 1rem;
    }
  }
`;

export default App;
